import Loading from 'app/atoms/Loading';
import { Suspense, useEffect, useState } from 'react';
import SanityHeader from '../../atoms/Sanity/SanityHeader/SanityHeader';
import './CityGuide.scss';
import SanityBody from '../../atoms/Sanity/SanityBody/SanityBody';
import CityGuideCardContainer from './CityGuideCard/CityGuideCardContainer';
import CityGuideImagesSection from './CityGuideImagesSection/CityGuideImagesSection';
import TitledPropertyCarouselSection from 'app/molecules/TitledPropertyCarouselSection/TitledPropertyCarouselSection';
import { sanityClient } from '../../../sanity.io/config';
import { CityGuideProps } from './CityGuide.types';
import SanitySubHeader from '../../atoms/Sanity/SanitySubHeader/SanitySubHeader';
import SanityHeroSection from '../../atoms/Sanity/SanityHeroSection/SanityHeroSection';
import { useParams } from 'react-router';
import Copyright from '../../molecules/Footer/Copyright';
import CityGuideMapSection from '../../molecules/city-guide-map/CityGuideMapSection';

function CityGuide() {
  const { city } = useParams<{ city: string }>();
  const [data, setData] = useState<CityGuideProps>();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[ _type== "cityGuide" && slug.current == "${city.toLowerCase()}"]{...,city->, neighborhoodGuides[]->{neighborhood, neighborhoodSummary, slug}}`
      )
      .then(response => {
        if (response && response[0]) {
          setData(response[0]);
        }
      });
  }, []);

  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      {data && (
        <>
          <SanityHeroSection heroImageUrl={data.heroImage.asset._ref} />
          <section className="d-flex sanity-section">
            <div className="city-guide-container col-12 col-sm-8">
              <SanityHeader title={`${data.city.name} City Guide`} date={data._createdAt} />
              <SanitySubHeader subHeader={data.header} />
              <SanityBody body={data.body} />
            </div>
            <CityGuideCardContainer neighborhoodGuides={data.neighborhoodGuides ? data.neighborhoodGuides.slice(0, 4) : []} />
          </section>
          <CityGuideImagesSection carouselImages={data.carouselImages} />
          <section className="d-flex sanity-section">
            <div className="city-guide-container col-12 col-sm-8">
              <SanityBody body={data.body2} />
            </div>
            <CityGuideCardContainer neighborhoodGuides={data.neighborhoodGuides ? data.neighborhoodGuides.slice(4, 8) : []} />
          </section>
          <div>
            {!!data && !!data.places && !!data.places.length && <CityGuideMapSection places={data.places} city={data.city.name} />}
            <div className="col-lg-12 col-md-12 copy-right live-like-a-local-copyright">
              <Copyright />
            </div>
          </div>
          <TitledPropertyCarouselSection
            title=""
            subtitle={`Check out some of our most popular ${data.city.name} homes `}
            url="/properties"
            city={city}
          />
        </>
      )}
    </Suspense>
  );
}
export default CityGuide;
